"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _BaseRenderer2 = _interopRequireDefault(require("./BaseRenderer"));

var _LayerTransformData = _interopRequireDefault(require("../layers/LayerTransformData"));

var _ContentFrameData = _interopRequireDefault(require("../store/ContentFrameData"));

var _isNil = _interopRequireDefault(require("../../utils/object/isNil"));

var _isNotNil = _interopRequireDefault(require("../../utils/object/isNotNil"));

var _creative = require("../../constants/creative");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var DEFAULT_CONTENT_FRAME_INDEX = 0;

var LayerRenderer = /*#__PURE__*/function (_BaseRenderer) {
  (0, _inherits2["default"])(LayerRenderer, _BaseRenderer);

  var _super = _createSuper(LayerRenderer);

  function LayerRenderer() {
    var _this;

    (0, _classCallCheck2["default"])(this, LayerRenderer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_hasRendered", false);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_hasUnrecoverableError", false);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_layerTransformData", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_contentFrameData", null);
    return _this;
  }

  (0, _createClass2["default"])(LayerRenderer, [{
    key: "getContentFrameData",

    /**
     * Get the data from the content store for the layer
     * @param {number} frameNum
     * @returns {ContentFrameData}
     * @private
     */
    value: function getContentFrameData(frameNum) {
      if ((0, _isNil["default"])(this._creativeLayer) || (0, _isNil["default"])(this._creativeLayer.contentId)) return null;

      var contentFrameData = this._contentStore.getContentFrameData(this._creativeLayer, this.getContentFrameIndex(frameNum));

      if (!_ContentFrameData["default"].isContentFrameData(contentFrameData)) return null;
      return contentFrameData;
    }
    /**
     * Draws image data to the given context.
     * @param {CanvasRenderingContext2D} context - canvas rendering context
     * @param {Number} currentFrame - current frame of the creative to render
     * @param {ContentFrameData} contentFrameData - the data for the current frame from the content store.
     * @param {LayerTransformData} layerTransformData - data about the current layer transform.
     * @private
     */

  }, {
    key: "drawLayerAtFrame",
    value: function drawLayerAtFrame(context, currentFrame, contentFrameData, layerTransformData) {
      var layerBitmap = contentFrameData.bitmap,
          contentWidth = contentFrameData.contentWidth,
          contentHeight = contentFrameData.contentHeight;
      if ((0, _isNil["default"])(layerBitmap) || (0, _isNil["default"])(layerTransformData)) return;
      var contentDimensionMode = layerTransformData.contentDimensionMode,
          contentX = layerTransformData.contentX,
          contentY = layerTransformData.contentY,
          scaledHeight = layerTransformData.scaledHeight,
          scaledTransformX = layerTransformData.scaledTransformX,
          scaledTransformY = layerTransformData.scaledTransformY,
          scaledWidth = layerTransformData.scaledWidth;
      if (scaledWidth <= 0 || scaledHeight <= 0) return; // Draw image data from CanvasLayer

      if (contentDimensionMode === _BaseRenderer2["default"].INTRINSIC_DIMENSIONS) {
        /*
          In this mode, we do not try to capture a range of data from the bitmap data and instead use all of it.
          This was done in part to better support SVGs
         */
        context.drawImage(layerBitmap, scaledTransformX, scaledTransformY, scaledWidth, scaledHeight);
      } else {
        /*
          In this mode, capture a specific range of the bitmap data and draw it to the canvas
          Note: Odd-numbered width/height will result in a fractional value for X/Y so do not floor
         */
        context.drawImage(layerBitmap, contentX, contentY, contentWidth, contentHeight, scaledTransformX, scaledTransformY, scaledWidth, scaledHeight);
      }
    }
    /**
     * Uses Creative and some local properties to create a CanvasLayerFrameData object
     *
     * @param frameNum
     * @returns {LayerTransformData}
     * @private
     */

  }, {
    key: "_calculateLayerTransformData",
    value: function _calculateLayerTransformData(frameNum) {
      if (!this._creativeLayer) return null;

      var transform = this._creativeLayer.getAbsoluteTransformsAtFrame(frameNum);

      var visible = this._creativeLayer.isVisibleForFrame(frameNum);

      var alphaCompositeRule = this._creativeLayer.alphaCompositeRule; // TODO figure out how to make this not be a side effect

      var contentFrameData = this._contentStore.getContentFrameData(this._creativeLayer, this.getContentFrameIndex(frameNum));

      if ((0, _isNotNil["default"])(contentFrameData)) {
        var contentHeight = contentFrameData.contentHeight,
            contentWidth = contentFrameData.contentWidth;
        this._contentHeight = contentHeight;
        this._contentWidth = contentWidth;

        if (this.contentScaleMode === _BaseRenderer2["default"].SCALE_MODE_SCALE_TO_FIT) {
          var media = this._creativeLayer.media;
          var mediaHeight = media.height,
              mediaWidth = media.width;
          this._contentScaleX = mediaWidth / contentWidth;
          this._contentScaleY = mediaHeight / contentHeight;
        }
      }

      var alpha = transform.alpha,
          filters = transform.filters,
          rotation = transform.rotation,
          scale = transform.scale,
          translation = transform.translation;
      return new _LayerTransformData["default"](this.contentDimensionMode, 0, 0, this.contentWidth, this.contentHeight, this.contentScaleX, this.contentScaleY, alpha, rotation, scale, translation, alphaCompositeRule, visible, filters);
    }
    /**
     * Gets layer data and calls the draw method if appropriate
     *
     * @param {CanvasRenderingContext2D} context - canvas rendering context
     * @param {Number} frameNum - which frame to draw
     * @param {Rectangle} canvasDimensions
     */

  }, {
    key: "renderLayer",
    value: function renderLayer(context, frameNum, canvasDimensions) {
      if ((0, _isNil["default"])(context)) return;
      var contentFrameData = this.getContentFrameData(frameNum);
      this._contentFrameData = contentFrameData; // No need to draw if there isn't any data.

      if (!contentFrameData) return; // If no layer data, we cannot draw

      var layerTransformData = this.getLayerTransformData(frameNum);
      if ((0, _isNil["default"])(layerTransformData)) return;
      var transformedLayer;
      var transformedLayerWidth = canvasDimensions.width;
      var transformedLayerHeight = canvasDimensions.height;
      var transformWidthDiff = 0;
      var transformHeightDiff = 0; // If a layer specifies it has no transforms (group) then it must return its own bitmap.

      if (this.contentTransformMode === _BaseRenderer2["default"].TRANSFORM_PASSTHROUGH) {
        transformedLayer = this.getLayerBitmap(frameNum);
      } else {
        // Apply transforms to layer
        // This draws the bitmap to a canvas at its current transform (scale, position, etc)
        // and returns the canvas. We draw that canvas to the main canvas below.
        transformedLayer = this._layerTransformer.transformAndRenderLayer(this, frameNum, contentFrameData, layerTransformData);
        transformedLayerWidth = this._layerTransformer.dimensions.width;
        transformedLayerHeight = this._layerTransformer.dimensions.height;
        transformWidthDiff = this._layerTransformer.dimensions.width - canvasDimensions.width;
        transformHeightDiff = this._layerTransformer.dimensions.height - canvasDimensions.height;
      }

      if ((0, _isNil["default"])(transformedLayer)) return; // Apply filters to layer

      var alpha = layerTransformData.alpha,
          alphaCompositeRule = layerTransformData.alphaCompositeRule,
          filters = layerTransformData.filters;

      var processedBitmap = this._filterProcessor.applyFilters(this._elementId, transformedLayer, this._layerTransformer.dimensions, context, filters, canvasDimensions);

      if ((0, _isNil["default"])(processedBitmap)) return; // Set the blend mode and alpha (should set to defaults in absence of values)

      context.globalAlpha = alpha;
      context.globalCompositeOperation = _creative.BLEND_MODE_TO_COMPOSITE_OPERATION[alphaCompositeRule]; // Draw layer to context

      context.drawImage(processedBitmap, // Capture full size of the intermediate transform layer
      0, 0, transformedLayerWidth, transformedLayerHeight, // Draw offset to the rendered canvas dimensions
      // the "processedBitmap" may be slightly larger that the normal canvas to
      // accommodate different filters. Centering it removes any overflow.
      -0.5 * transformWidthDiff, -0.5 * transformHeightDiff, transformedLayerWidth, transformedLayerHeight);
      this._hasRendered = true;
    }
    /**
     * Calculates and then sets a local copy of canvas layer data which is then used as a way to determine
     * if the next requested frame requires a redraw.
     *
     * @param frameNum
     * @returns {LayerTransformData}
     */

  }, {
    key: "getLayerTransformData",
    value: function getLayerTransformData(frameNum) {
      // TODO figure out how to remove this side effect or refactor
      this._layerTransformData = this._calculateLayerTransformData(frameNum);
      return this._layerTransformData;
    }
    /**
     * Returns the content-relative frame index needed to get the content frame from ContentStore.
     * @param {number} rootFrameNumber - creative-relative frame number
     * @returns {number}
     */

  }, {
    key: "getContentFrameIndex",
    value: function getContentFrameIndex(rootFrameNumber) {
      // eslint-disable-line no-unused-vars
      return DEFAULT_CONTENT_FRAME_INDEX;
    }
  }, {
    key: "shouldDrawNewFrame",
    value: function shouldDrawNewFrame(frameNum) {
      // If there was a fatal error, no retrying.
      if (this._hasUnrecoverableError) return false; // If this has never rendered, keep trying.

      if (!this._hasRendered) return true;

      var layerTransformData = this._calculateLayerTransformData(frameNum);

      if ((0, _isNil["default"])(layerTransformData)) return false;
      if (!layerTransformData.equals(this._layerTransformData)) return true;
      var contentFrameData = this.getContentFrameData(frameNum);
      return (0, _isNotNil["default"])(contentFrameData) && !contentFrameData.equals(this._contentFrameData);
    }
  }], [{
    key: "isLayerRenderer",
    value: function isLayerRenderer(inLayerRenderer) {
      return inLayerRenderer instanceof LayerRenderer;
    }
  }]);
  return LayerRenderer;
}(_BaseRenderer2["default"]);

exports["default"] = LayerRenderer;